import hjf from "../view/hjf/hjf";

const Homenew = r =>
  require.ensure([], () => r(require("../view/HomeNew")), "homenew");
const Homepage = r =>
  require.ensure([], () => r(require("../view/Home")), "homepage");
const Jfpay = r =>
  require.ensure([], () => r(require("../view/jfpay")), "jfpay");
const Discover = r =>
  require.ensure([], () => r(require("../view/discover/discover")), "discover");
const Dissearch = r =>
  require.ensure([], () => r(require("../view/discover/search")), "dissearch");
const Detail = r =>
  require.ensure([], () => r(require("../view/discover/detail")), "detail");
const Center = r =>
  require.ensure([], () => r(require("../view/discover/center")), "center");
const Sale = r =>
  require.ensure([], () => r(require("../view/discover/sale")), "sale");
const DiscoverList = r =>
  require.ensure(
    [],
    () => r(require("../view/discover/discoverList")),
    "discoverList"
  );
const cymall = r =>
  require.ensure([], () => r(require("../view/cymall/index")), "cymall");
const cymallnew = r =>
  require.ensure([], () => r(require("../view/cymallnew/index")), "cymallnew");
const WxAuthority = r =>
  require.ensure([], () => r(require("../view/WxAuthority/index")), "WxAuthority");
const WxAuthority2 = r =>
  require.ensure([], () => r(require("../view/WxAuthority/index2")), "WxAuthority2");
const Mine = r => require.ensure([], () => r(require("../view/Mine")), "Mine");
const Minenew = r => require.ensure([], () => r(require("../view/Minenew")), "Minenew");
const Search = r =>
  require.ensure([], () => r(require("../view/Search")), "search");
const pageSearch = r =>
  require.ensure([], () => r(require("../view/pageSearch")), "pageSearch");
const pageSearch1212 = r =>
  require.ensure(
    [],
    () => r(require("../view/pageSearch1212")),
    "pageSearch1212"
  );
const Notes = r =>
  require.ensure([], () => r(require("../view/notes")), "notes");
const Order = r =>
  require.ensure([], () => r(require("../view/order")), "order");
const myOrder = r =>
  require.ensure([], () => r(require("../view/myOrder/order")), "myOrder");
const pinTuanOrder = r =>
  require.ensure(
    [],
    () => r(require("../view/pinTuanOrder/order")),
    "pinTuanOrder"
  );
const shzfOrder = r =>
  require.ensure(
    [],
    () => r(require("../view/myOrder/shzfOrder")),
    "shzfOrder"
  );
const GetLimt = r =>
  require.ensure([], () => r(require("../view/getLimt")), "getLimt");
const Video = r =>
  require.ensure([], () => r(require("../view/video")), "video");
const Other = r =>
  require.ensure([], () => r(require("../view/Other")), "Other");
const spOne = r =>
  require.ensure([], () => r(require("../view/spOne")), "spOne");
const spTwo = r =>
  require.ensure([], () => r(require("../view/spTwo")), "spTwo");
const Article = r =>
  require.ensure([], () => r(require("../view/Article"), "Article"));
const Pointsmall = r =>
  require.ensure([], () => r(require("../view/pointsmall"), "Pointsmall"));
const WlDetail = r =>
  require.ensure([], () => r(require("../view/wl"), "WlDetail"));
const GroupHome = r =>
  require.ensure([], () =>
    r(require("../view/groupBooking/groupHome.vue"), "GroupHome")
  );
const GroupSuccess = r =>
  require.ensure([], () =>
    r(require("../view/groupBooking/groupSuccess.vue"), "GroupSuccess")
  );
const MyGroup = r =>
  require.ensure([], () =>
    r(require("../view/groupBooking/myGroup.vue"), "MyGroup")
  );
const GroupDetails = r =>
  require.ensure([], () =>
    r(require("../view/groupBooking/groupDetails.vue"), "GroupDetails")
  );
const HJF = r =>
  require.ensure([], () => r(require("../view/hjf/index.vue"), "hjf"));
const SaasHjf = r =>
  require.ensure([], () => r(require("../view/saasHjf/index.vue"), "saasHjf"));
const HJFSearch = r =>
  require.ensure([], () =>
    r(require("../view/hjfSearch/index.vue"), "hjfSearch")
  );
const HJFStrategy = r =>
  require.ensure([], () =>
    r(require("../view/hjfStrategy/index.vue"), "hjfStrategy")
  );
const ExpiredPoints = r =>
  require.ensure([], () =>
    r(require("../view/ExpiredPoints/index.vue"), "ExpiredPoints")
  );
const PointsDetail = r =>
  require.ensure([], () =>
    r(require("../view/PointsDetail/index.vue"), "PointsDetail")
  );
const MyActivity = r =>
  require.ensure([], () =>
    r(require("../view/myActivity/index.vue"), "MyActivity")
  );
const cymall2 = r =>
  require.ensure([], () => r(require("../view/cymall2/index.vue"), "cymall2"));
const cymall3 = r =>
  require.ensure([], () => r(require("../view/cymall3/index.vue"), "cymall3"));
// 果树分享页面
const Invite = r =>
  require.ensure([], () => r(require("../view/invite/index.vue"), "Invite"));

const pageSearchOld = r =>
  require.ensure(
    [],
    () => r(require("../view/pageSearchOld")),
    "pageSearchOld"
  );

export default new VueRouter({
  mode: 'hash',//默认是hash，hash就会有#,history
  routes: [
    {
      path: "/",
      redirect: "/homepage",
      meta: {
        keepAlive: true
        // showTab: true
      }
    },
    {
      path: "/hjf",
      name: "hjf",
      component: HJF,
      meta: {
        title: "畅由积分当钱花"
      }
    },
    {
      path: "/saasHjf",
      name: "saasHjf",
      component: SaasHjf,
      meta: {
        title: "畅由积分当钱花"
      }
    },
    {
      path: "/hjfStrategy",
      name: "hjfStrategy",
      component: HJFStrategy,
      meta: {
        title: "畅由积分攻略"
      }
    },
    {
      path: "/hjfSearch",
      name: "hjfSearch",
      component: HJFSearch,
      meta: {
        title: "搜索"
      }
    },
    {
      path: "/points-detail",
      name: "points-detail",
      component: PointsDetail,
      meta: {
        title: "积分明细"
      }
    },
    {
      path: "/expired-points",
      name: "expired-points",
      component: ExpiredPoints,
      meta: {
        title: "畅由会员积分"
      }
    },
    {
      path: "/homenew",
      name: "Homenew",
      component: Homenew,
      meta: {
        keepAlive: true
        // showTab: true
      }
    },
    {
      path: "/homepage",
      name: "Homepage",
      component: Homepage,
      meta: {
        keepAlive: true
        // showTab: true
      }
    },
    {
      path: "/pageSearch",
      name: "pageSearch",
      meta: {
        title: "搜索"
      },
      component: pageSearch
    },
    {
      path: "/pageSearchOld",
      name: "pageSearchOld",
      meta: {
        title: "搜索"
      },
      component: pageSearchOld
    },
    {
      path: "/pageSearch1212",
      name: "pageSearch1212",
      meta: {
        title: "搜索"
      },
      component: pageSearch1212
    },
    {
      path: "/jfpay",
      name: "Jfpay",
      component: Jfpay,
      meta: {
        keepAlive: true
        // showTab: true
      }
    },
    {
      path: "/discover",
      name: "Discover",
      component: Discover,
      meta: {
        // showTab: browser.jfmore ? false:true
      }
    },
    {
      path: "/dissearch",
      name: "Dissearch",
      component: Dissearch,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/detail",
      name: "Detail",
      component: Detail
    },
    {
      path: "/spOne",
      name: "spOne",
      component: spOne
    },
    {
      path: "/spTwo",
      name: "spTwo",
      component: spTwo
    },
    {
      path: "/center",
      name: "Center",
      component: Center
    },
    {
      path: "/sale",
      name: "Sale",
      component: Sale
    },
    {
      path: "/discoverList",
      name: "DiscoverList",
      component: DiscoverList
    },
    {
      path: "/cymall",
      name: "cymall",
      component: cymall3,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/cymallnew",
      name: "cymallnew",
      component: cymallnew,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/WxAuthority",
      name: "WxAuthority",
      component: WxAuthority,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/WxAuthority2",
      name: "WxAuthority2",
      component: WxAuthority2,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/member",
      name: "Member",
      component: Mine,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/minenew",
      name: "Minenew",
      component: Minenew,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/search",
      name: "Search",
      component: Search,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/search/:id",
      name: "Search",
      component: Search,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/notes",
      name: "Notes",
      component: Notes,
      meta: {
        keepAlive: true
      }
    },
    {
      path: "/order",
      name: "Order",
      component: myOrder,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/shzfOrder",
      name: "ShzfOrder",
      component: shzfOrder,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/pinTuanOrder",
      name: "pinTuanOrder",
      component: pinTuanOrder,
      meta: {
        keepAlive: false
      }
    },
    {
      path: "/getLimt/:activityId",
      name: "GetLimt",
      component: GetLimt
    },
    {
      path: "/getLimt",
      name: "GetLimt",
      component: GetLimt
    },
    {
      path: "/video",
      name: "Video",
      component: Video
    },
    {
      path: "/other",
      name: "Other",
      component: Other
    },
    {
      path: "/article",
      name: "article",
      component: Article
    },
    {
      path: "/pointsmall",
      name: "pointsmall",
      component: Pointsmall
    },
    {
      path: "/wlDetail",
      name: "wlDetail",
      component: WlDetail
    },
    {
      path: "/groupHome",
      name: "groupHome",
      component: GroupHome
    },
    {
      path: "/groupSuccess",
      name: "groupSuccess",
      component: GroupSuccess
    },
    {
      path: "/myGroup",
      name: "myGroup",
      component: MyGroup
    },
    {
      path: "/groupDetails",
      name: "groupDetails",
      component: GroupDetails
    },
    {
      path: "/myActivity",
      name: "myActivity",
      component: MyActivity
    },
    {
      path: "/invite",
      name: "invite",
      component: Invite
    }
  ]
});
